<div class="mt-2">
  <div class=" mb-2" *ngFor="let menu of menuService.pagesMenu">
    <ul class="flex flex-col space-y-1">
      <!-- List items -->
      <li *ngFor="let item of menu.items">
        <!-- Menu List -->
        <div (click)="$event.stopPropagation();toggleMenu(item)" class="group relative text-muted-foreground">
          <!-- Icon -->
          <div [ngClass]="item.active && !menuService.showSideBar ? 'text-primary' : 'text-muted-foreground/50'"
            class="pointer-events-none absolute m-2">
            <svg-icon *ngIf="item.icon" src="{{ item.icon }}" [svgClass]="'h-6 w-6'"> </svg-icon>
            <mat-icon *ngIf="item.matIcon" class="material-icons-outlined">{{ item.matIcon }}</mat-icon>
          </div>
          <!-- Condition -->
          <ng-container [ngTemplateOutlet]="item.children && item.children.length > 0 ? childMenu : parentMenu"
            [ngTemplateOutletContext]="{ item: item }">
          </ng-container>

          <!-- Workaround:: Enable routerLink -->
          <ng-template #parentMenu let-item="item">
            <div routerLink="{{ item.route }}"
              class="flex h-9 cursor-pointer items-center justify-start rounded text-muted-foreground hover:bg-card hover:text-foreground">
              <a routerLinkActive="text-primary"
                class="ml-10 truncate text-md font-semibold tracking-wide focus:outline-none">
                {{ item.label | translate }}
              </a>
            </div>
          </ng-template>

          <!-- Workaround:: Disable routerLink -->
          <ng-template #childMenu let-item="item">
            <div class="flex h-9 cursor-pointer items-center justify-start rounded hover:bg-card">
              <a
                class="ml-10 truncate text-md font-semibold tracking-wide text-muted-foreground focus:outline-none group-hover:text-foreground">
                {{ item.label | translate }}
              </a>
            </div>
          </ng-template>

          <!-- Arrow Icon -->
          <button *ngIf="item.children && item.children.length > 0" [ngClass]="{'rotate-90': item.expanded }"
            class="pointer-events-none absolute top-1 right-0 flex items-center p-1 text-muted-foreground/50 transition-all duration-500">
            <svg-icon src="assets/icons/chevron-right.svg" [svgClass]="'h-5 w-5'"> </svg-icon>
          </button>

        </div>

        <!-- Submenu items -->
        <app-sidebar-submenu [submenu]="item"></app-sidebar-submenu>
      </li>
    </ul>

    <div class="pt-3" *ngIf="menu.separator">
      <hr class="border-dashed border-border" />
    </div>
  </div>
</div>